import React from "react";
import { StyleSheet, View, Text, Platform } from "react-native";

import ImageComponent from "../../common/ImageComponent";
import ManaButton from "../../common/ManaButton";
import AppTheme from "../../AppTheme";

export default function NoJournalEntries(props) {
  return (
    <View style={styles.container}>
      <ImageComponent
        image={require("../../../../assets/GrowthMari.png")}
        styles={styles.image}
      />

      <Text style={styles.text}>No journal entries yet...</Text>

      <Text style={styles.text}>
        Journaling has proven benefits, and it doesn’t have to be time
        consuming.
      </Text>

      <Text style={[styles.text, { marginTop: 10 }]}>
        Why not tap one of the smileys above to get started?
      </Text>

      <ManaButton
        text="Learn More"
        onPress={() => {}}
        style={[styles.button]}
        buttonText={styles.buttonText}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    textAlign: "center",
    maxWidth: 240,
  },
  button: {
    width: 200,
    height: 50,
    marginTop: 20
  },
  image: {
    width: 131,
    height: 148,
  },
});
